<template>
  <PageContentWrapper>
    <h1 class="hidden md:block text-center mb-0">
      {{ archived ? 'Archivierte Hinweise' : 'Hinweise' }}
    </h1>
    <div class="flex flex-row justify-end">
      <AppButton
        type="primary"
        plain
        @click="show = true"
      >
        <template #icon>
          <FaIcon name="lightbulb" variant="light" />
        </template>
        Einführung
      </AppButton>
      <OnboardingModal
        :show="show"
        @close="show = false"
      />
    </div>
    <div class="flex flex-wrap -mx-4 justify-center my-5">
      <div class="flex-1 px-4 text-center">
        <ul
          v-if="news.length > 0"
          class="no-padding flex flex-col gap-2 m-0"
        >
          <li
            v-for="({ id, title, createdAt }) in news"
            :key="id"
          >
            <DetailPageLink
              :title="title"
              :to="{ name: Finanzmanager.HINWEISE_SHOW, params: { id } }"
            >
              <ElTag
                v-if="unreadHints[UnreadHintType.News].has(id)"
                type="primary"
                class="ml-3"
                round
              >
                Neu
              </ElTag>
              <template #meta>
                <span class="text-gray-700 text-xs shrink-0 md:ml-auto">
                  {{ createdAt }}
                </span>
              </template>
            </DetailPageLink>
          </li>
        </ul>

        <div
          v-else
          class="text-center mt-2.5"
          v-text="'Keine Einträge'"
        />
      </div>
    </div>

    <div class="text-center">
      <RouterLink
        v-slot="{ navigate }"
        :to="{
          name: Finanzmanager.HINWEISE,
          query: { archived: archived ? 'false' : 'true'}
        } "
        custom
      >
        <AppButton
          type="primary"
          plain
          @click="navigate"
        >
          <template #icon>
            <FaIcon :name="archived ? 'mailbox' : 'box-archive'" variant="light" />
          </template>
          {{ archived ? 'Hinweise' : 'Archiv' }}
        </AppButton>
      </RouterLink>
    </div>
  </PageContentWrapper>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElTag } from 'element-plus';
import { ref } from 'vue';
import { useUnreadHintStore } from '@/application/store/unreadHintStore';

import type { News } from '@/api/news/types';
import OnboardingModal from '@/application/components/OnboardingModal.vue';
import { Finanzmanager } from '@/application/router/types/types';
import { UnreadHintType } from "@/api/unreadHint/types";
import DetailPageLink from "@/application/components/DetailPageLink.vue";
import PageContentWrapper from '@/application/layouts/ContentWrapper/PageContentWrapper.vue';

interface Props {
  news: News[]
  archived?: boolean,
}

defineProps<Props>();

const show = ref(false);

const unreadHints = useUnreadHintStore();
</script>
